import { render, staticRenderFns } from "./EventHub.vue?vue&type=template&id=6902722d&scoped=true"
import script from "./EventHub.vue?vue&type=script&lang=js"
export * from "./EventHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6902722d",
  null
  
)

export default component.exports